import { useEffect, useRef, useState } from "react"
import "./SearchForm.css"

export type SearchFormProps = {
  onChange?: Function
  placeholder?: string
  clearLabel?: string
}

export function SearchForm({
  onChange,
  placeholder,
  clearLabel,
}: SearchFormProps) {
  //let idTimeout: ReturnType<typeof setTimeout>
  const toDuration: number = 500

  const inputRef = useRef<HTMLInputElement>(null)
  const idTimeout = useRef<ReturnType<typeof setTimeout>>()

  const [value, setValue] = useState<string>()

  const onKeyUp = () => {
    if (idTimeout.current) {
      clearTimeout(idTimeout.current)
    }
    idTimeout.current = setTimeout(() => {
      if (inputRef.current) {
        setValue(inputRef.current.value)
      }
    }, toDuration)
  }

  const clear = () => {
    if (inputRef.current) {
      inputRef.current.value = ""
      setValue("")
    }
  }

  useEffect(() => {
    if (typeof onChange === "function") {
      onChange(value)
    }
  }, [value, onChange])

  return (
    <div className="avlav-searchform">
      <label htmlFor="search" className="sr-only">
        {placeholder}
      </label>
      <input
        ref={inputRef}
        type="search"
        name="search"
        onKeyUp={onKeyUp}
        placeholder={placeholder}
        className="avlav-searchfield"
      />
      {value && (
        <div className="avlav-searchreset-wrapper">
          <button
            onClick={clear}
            className="av-rounded-button avlav-searchreset"
          >
            <span className="av-button-mask">
              <span className="av-text-button">{clearLabel}</span>
            </span>
          </button>
        </div>
      )}
    </div>
  )
}
